import { Workbook } from 'exceljs'
import { cardIssuePointGetAddress } from '@prodcard/core'
import { AdditionalOptsWorksheet } from '../interfaces'
import { head, last } from 'lodash'

export function createSheetCardIssuePoints(workbook: Workbook, sheetName: string, opts: AdditionalOptsWorksheet) {
  const worksheet = workbook.addWorksheet(sheetName)
  worksheet.columns = [
    { header: '№' },
    { header: 'Адрес', width: 40 },
    { header: 'Количество окон', width: 15 },
    { header: 'Контактный телефон', width: 25 },
    { header: 'Режим работы', width: 25 },
  ]

  opts.cardIssuePoints.forEach(cip => {
    worksheet.addRow([
      `${opts.municipalEntities.find(me => me.id === cip.municipalEntityId)?.index}.${cip.number}`,
      cardIssuePointGetAddress(cip) + (cip.comment ? ` (${cip.comment})` : ''),
      cip.windowsCount,
      cip.phone,
      cip.openingHours,
    ])
  })

  const countRow = worksheet.addRow([`Итого: ${opts.count}`, ...new Array(worksheet.columns.length - 1)])
  const letters = worksheet.columns.map(c => c.letter)
  worksheet.mergeCells(`${head(letters)}${countRow.number}:${last(letters)}${countRow.number}`)
}
